import { useCallback, useEffect, useState } from "react";
import { useSelections } from "../../context/Selections";
import { ReactComponent as IconLogoFooter } from "../../assets/icons/footer/logo-footer.svg";

export function Footer({ app }) {
  const [updateDate, setUpdateDate] = useState();
  const { selections } = useSelections();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getNameVariable = async (nameVariable) => {
    try {
      const variableModel = await app.variable.getByName(nameVariable);
      const layout = await variableModel.getLayout();
      setUpdateDate(layout.qText);
    } catch (error) {
      console.error("Erro ao obter a variável:", error);
    }
  };

  useEffect(() => {
    if (app) {
      getNameVariable("vAtualizacao", 5);
    }
  }, [app, getNameVariable, selections]);
  return (
    <footer className="container-footer">
      <div className="text-updateDate">
        <span>ATUALIZADO EM:</span> <span>{updateDate}</span>
      </div>

      <div className="container-logo-footer">
        <IconLogoFooter />
      </div>
    </footer>
  );
}
